import { useQuery } from "@tanstack/react-query";
import { toggleServiceTemplateFavourite } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Toggle favourite state of given serviceTemplate via RCB Service API.
 */ function useToggleServiceTemplateFavourite(id) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.toggleFavouriteService(id), ({ signal })=>toggleServiceTemplateFavourite({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: String(id)
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: String(id)?.trim().length > 0 && !isNaN(Number(id))
    });
}
export { useToggleServiceTemplateFavourite };
